import { axios } from '../../clients/axios'

export default {
  namespaced: true,
  state: {
    role: null,
    features: []
  },
  getters: {
    getFeatureAccess: (state) => (feature) => {
      return state.features.find((f) => f.feature === feature)
    },
    getRole: (state) => {
      return state.role
    }
  },
  mutations: {
    fetchFeatures(state, features) {
      state.features = features
    },
    fetchRole(state, role) {
      state.role = role
    }
  },
  actions: {
    async fetchRoleFeaturesAction(context) {
      try {
        let role = null
        const userId = context.rootGetters['auth/getUser'].userId
        const property = context.rootGetters['properties/getProperty']

        if (Number.isInteger(userId) && property) {
          const user = property.users.find((user) => user.userId === userId)
          role = user && user.role
          context.commit('fetchRole', role)
        }

        let uri = `${process.env.VUE_APP_API_URL}/roles/custom`

        const features = await axios.get(uri, { withCredentials: true })

        context.commit('fetchFeatures', features.data)

        return Promise.resolve(features.data)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async getAllRoles() {
      const result = await axios.get(
        `${process.env.VUE_APP_API_URL}/roles/custom/all`,
        { withCredentials: true }
      )

      return Promise.resolve(result.data)
    },
    async updateRole(context, params) {
      const { roleId, features } = params
      const result = await axios.patch(
        `${process.env.VUE_APP_API_URL}/roles/custom`,
        { roleId, features },
        { withCredentials: true }
      )

      return Promise.resolve(result.data)
    },
    async createRole(context, params) {
      const { role } = params
      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/roles/custom`,
        { role },
        { withCredentials: true }
      )

      return Promise.resolve(result.data)
    },
    async deleteRole(context, params) {
      const { roleId } = params
      const result = await axios.delete(
        `${process.env.VUE_APP_API_URL}/roles/custom`,
        { data: { roleId }, withCredentials: true },
        { withCredentials: true }
      )

      return Promise.resolve(result.data)
    }
  }
}
